import { PageSizes, StandardFonts } from 'pdf-lib';
import genmincho from '../../font/SourceHanSerif-Medium_extracted.otf';
import genmincho_bold from '../../font/SourceHanSerif-Bold_extracted.otf';

import { createPDFDocument, getFontArrayBuffer } from './pdf_create';
import { X_ALIGN_CENTER, Y_ALIGN_CENTER, drawTextInBox } from './pdfUtil/drawTextInBox';
import { getDisplayOriginWithOther, getDisplaySize } from '../../utils/Items';

import { getListOrderDetail } from '../../http/api/OrderAPI'
import { filterPartition, getOutputDestination, getPrintPages, getProductPartitionList, hasShopOrder } from '../../utils/orderForm';
import { postMarketPriceSearchTableInfoListAPI } from '../../http/api/MarketPriceAPI';

import { createGeneralOrderFormFooter, createGeneralOrderFormHeader, createGeneralOrderFormTableBones, getGeneralOrderFormPageParameter, outputGeneralOrderFormTableProductData } from './GeneralOrderFormPDF';
import { getDirectorEmployee } from '../../http/api/MasterAPI';
import {stripTrailingZeros} from "../../utils/decimal";

// 注文数量の出力
const outputGeneralOrderFormTableOrderQuantityData = (page, pageParameter, shops, rowIndex, columnIndex, outputData) => {

  const {
    margin, 
    rowHeight ,
    columnWidth ,
    orderUnitColumnLeft,
    fonts,
    tableDataStart_y,
  } = pageParameter;

  const { shopOrderInfo } = outputData;

  const dataStart_x = margin + columnWidth * columnIndex
  let text_y1 = tableDataStart_y - rowHeight * rowIndex

    let orderData = shopOrderInfo.find((shopOrderData) => shopOrderData.shopId === shops[0].shopId);
    
    if (orderData && orderData.orderQuantity >= 1) {
      let orderQuantityStr = orderData.orderQuantity.toString();

    drawTextInBox(page, orderQuantityStr, {
      x1: dataStart_x + orderUnitColumnLeft,
      x2: dataStart_x + columnWidth,
      y1: text_y1,
      y2: text_y1 - rowHeight + 2
    }, {
      font: fonts.mincho_font,
      size: 10,
      xAlign: X_ALIGN_CENTER,
      yAlign: Y_ALIGN_CENTER,
      xpadding: 0,
      yPadding: 0
    }) 
  }
}

// 価格表１サイクル出力
const outputOrderCheckFormForACycle = (
  pdfDoc,
  marketPriceInfo, 
  directorEmployeeInfo,
  priceInfoList,
  shippingDateInfo,
  pageParameter,
  outputShops
) => {
  let {width, height, rowNumber, columnNumber, shopSummary, productTypePartition, skipNoOrder, asSendingLabel} = pageParameter;

  let shopPriceInfoList
    = skipNoOrder
      ? priceInfoList.filter((priceInfo) => hasShopOrder(priceInfo, outputShops))
      : priceInfoList;

  let productPartitionList = filterPartition(shopPriceInfoList, pageParameter, rowNumber);
  
  let columnCount = productPartitionList
    .map((productPartition) => Math.ceil(productPartition.length / rowNumber !== 0 ? productPartition.length / rowNumber : 1))
    .reduce((prevCnt, thisCnt) => prevCnt + thisCnt, 0);

  let pageCountACycle = Math.max(Math.ceil(columnCount / columnNumber), 1);

  // ページの生成
  let pages = Array.from(new Array(pageCountACycle)).map((_, pageIndex) => {
    let page = pdfDoc.addPage([width, height]);
    let shopInfo = outputShops[0];
    if (
      pageParameter.directorEmployeePartition &&
      productPartitionList[pageIndex * pageParameter.columnNumber]
    ) {
      const directorEmployeeId =
        productPartitionList[pageIndex * pageParameter.columnNumber][0]
          ?.directorEmployeeId;
      const directorEmployeeObj = directorEmployeeInfo.find(
        (x) => x.directorEmployeeId == directorEmployeeId
      );
      pageParameter.directorEmployee = directorEmployeeObj ? directorEmployeeObj.directorEmployeeName || "なし" : null;
    }

    createGeneralOrderFormHeader(
      page,
      getTitle(asSendingLabel),
      getOutputDestination(shopInfo, shopSummary, asSendingLabel),
      shippingDateInfo,
      pageParameter
    );
    createGeneralOrderFormTableBones(page, pageParameter);
    createGeneralOrderFormFooter(page, pageParameter, marketPriceInfo);
    return page;
  });

  // 表の各データ行出力
  var lastName = "";
  var lastOrigin = "";
  var lastPriceDetailTypeId = 0;

  var totalDataIndex = 0;

  productPartitionList.forEach((dataList) => {
    if (dataList.length === 0) {
      totalDataIndex = Math.ceil(totalDataIndex / rowNumber + 1) * rowNumber
      return;
    }

    totalDataIndex = Math.ceil(totalDataIndex / rowNumber) * rowNumber

    dataList.forEach((data, index) => {
      let rowIndex = (totalDataIndex) % rowNumber;
      let columnIndex = Math.floor(totalDataIndex / rowNumber) % columnNumber;
      let pageIndex = Math.floor(totalDataIndex / (rowNumber * columnNumber));

      let displayOrigin = getDisplayOriginWithOther(data.origin, data.isOriginOther);

      let outputAsFirstOfType
        = !productTypePartition
          && (data.priceDetailTypeId !== lastPriceDetailTypeId)
          && totalDataIndex > 0;

      if (index % rowNumber === 0 || outputAsFirstOfType) {
        lastName = "";
        lastOrigin = "";
      }

      let outputData = {
        ...data,
        name: (lastName === data.productName ? "〃" : data.productName),
        origin: (lastName === data.productName && lastOrigin === displayOrigin ? "〃" : displayOrigin),
        size: getDisplaySize(data.rank, data.productClass, data.weight, data.weightUnit, data.packing, data.quantity),
        price: data.isShortage ? "-" : data.price,
        unit: data.orderingUnit,
        outputAsFirstOfType: outputAsFirstOfType
      }
      
      outputGeneralOrderFormTableProductData(pages[pageIndex], pageParameter, rowIndex, columnIndex, outputData);
      outputGeneralOrderFormTableOrderQuantityData(pages[pageIndex], pageParameter, outputShops, rowIndex, columnIndex, outputData);

      lastName = data.productName;
      lastOrigin = displayOrigin;
      lastPriceDetailTypeId = data.priceDetailTypeId;

      totalDataIndex += 1;
    })
  })

  return pages;
}

// 価格表(一般)PDF文書作成
async function createGeneralOrderCheckFormPDFDocumentInfo(
  marketPriceInfo,
  directorEmployeeInfo,
  priceInfoList,
  shops,
  destinations,
  isSample,
  shippingDateInfo,
  pdfSetting
) {

  const pdfDoc = await createPDFDocument();
  
  const genminchoArrayBuffer = await getFontArrayBuffer(genmincho);
  const genminchoBoldArrayBuffer = await getFontArrayBuffer(genmincho_bold);
  
  //日本語フォント読込
  const mincho_font = await pdfDoc.embedFont(genminchoArrayBuffer);
  const mincho_bold_font = await pdfDoc.embedFont(genminchoBoldArrayBuffer);
  const helvetica_bold_font =  await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const [ height, width ] = PageSizes.A4

  const pageParameter = getGeneralOrderFormPageParameter(width, height, {mincho_font, mincho_bold_font, helvetica_bold_font}, shops, destinations, pdfSetting);

  let {shopSummary} = pageParameter  
  
  if (shopSummary) {
    outputOrderCheckFormForACycle(pdfDoc, marketPriceInfo, directorEmployeeInfo, priceInfoList, shippingDateInfo, pageParameter, shops)
  } else {
    shops.forEach((shopInfo) => {
      outputOrderCheckFormForACycle(pdfDoc, marketPriceInfo, directorEmployeeInfo, priceInfoList, shippingDateInfo, pageParameter, [shopInfo])
    })
  }

  pdfDoc.setCreator("丸伊伊那青果　事務担当");
  
  // 選択されたページに対する余計なページを削除
  const printPages = getPrintPages(pdfSetting.printPageStr, pdfDoc.getPageCount())

  const deletePages
    = Array.from(new Array(pdfDoc.getPageCount()))
      .map((_, pageIndex) => pageIndex)
      .filter((pageIndex) => !printPages.includes(pageIndex + 1))
      .reverse();

  deletePages.forEach((pageIndex) => {
    pdfDoc.removePage(pageIndex);
  })

  return [await pdfDoc.save()];

}
export async function createGeneralOrderCheckFormPDF(
  marketPriceId, shops, destinations, isSample, shippingDateInfo, pdfSetting, marketPriceHistoryDate = null
) {
  let marketPriceResponse = await postMarketPriceSearchTableInfoListAPI({marketPriceId, marketPriceHistoryDate});
  let marketPriceInfo = marketPriceResponse.marketPriceTableInfoList[0];
  const directorEmployeeResponse = await getDirectorEmployee();
  const directorEmployeeInfo = directorEmployeeResponse.masterVarInfo.map((element) => ({
    directorEmployeeId: element.varCd,
    directorEmployeeName: element.varValue1,
  }));

  const orderShippingDateInfo = pdfSetting.datePartition ? shippingDateInfo : {shippingDateFrom: marketPriceHistoryDate, shippingDateTo: null};

  let res = await getListOrderDetail({
    marketPriceId,
    marketPriceHistoryDate, 
    orderDateFrom : orderShippingDateInfo.shippingDateFrom,
    orderDateTo : orderShippingDateInfo.shippingDateTo
  });

  let marketPriceInfoList = res.listOrderDetailInfo
              .filter((data) => data.isCustomerOrder)
              .map((data)=>({
                ...data,
                price: data.marketPrice,
                shopOrderInfo: data.shopOrderInfo.map((shopOrder) => ({
                  ...shopOrder,
                  orderQuantity : data.marketPriceHistoryDate == marketPriceHistoryDate ? stripTrailingZeros(shopOrder.orderQuantity) : 0
                }))
              }));        

  return await createGeneralOrderCheckFormPDFDocumentInfo(
    marketPriceInfo,
    directorEmployeeInfo,
    marketPriceInfoList,
    shops,
    destinations,
    isSample,
    orderShippingDateInfo,
    pdfSetting
  );
 
}

const getTitle = (asSendingLabel) => {
  return asSendingLabel ? "送り状" : "市況価格表";
}
